require('../../assets/landing.js');
